import AntCheckbox, { type CheckboxProps as AntCheckboxProps } from "antd/lib/checkbox";
import { CheckboxGroupProps as AntCheckboxGroupProps, CheckboxRef } from "antd/lib/checkbox";
import { FC, forwardRef, ForwardRefExoticComponent, RefAttributes } from "react";

export type CheckboxProps = AntCheckboxProps;

export type CheckboxGroupOptions = {
    label: string;
    value: string;
    disabled?: boolean;
};

export type CheckboxGroupProps = AntCheckboxGroupProps & {
    options?: CheckboxGroupOptions[];
};

type CompoundedComponent = ForwardRefExoticComponent<CheckboxProps & RefAttributes<CheckboxRef>> & {
    Group: FC<CheckboxGroupProps>;
};

const InternalCheckbox = forwardRef<CheckboxRef, CheckboxProps>((props, ref) => {
    return <AntCheckbox ref={ref} {...props} />;
});

InternalCheckbox.displayName = "Checkbox";

export const Checkbox = InternalCheckbox as CompoundedComponent;

Checkbox.Group = AntCheckbox.Group;
